import { useEffect, useState } from "react";
import { FetchImageByImageId } from "../api/ServerApi";
import { getCachedImage, setCachedImage } from "../utils/imageCache";

export function usePartySymbolImage(imageId) {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!imageId) {
      setImageUrl(null);
      return;
    }

    const cached = getCachedImage(imageId);
    if (cached) {
      setImageUrl(cached);
      return;
    }

    let cancelled = false;
    setLoading(true);

    FetchImageByImageId(imageId)
      .then((res) => {
        let url = null;

        // backend returns array
        if (Array.isArray(res) && res.length > 0) {
          url = res[0]?.ImageUrl || null;
        }

        if (!cancelled && url) {
          setImageUrl(url);
          setCachedImage(imageId, url);
        }
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [imageId]);

  return { imageUrl, loading };
}
